import { useEffect } from "react";

export default function RedirectToWhatsApp() {
  useEffect(() => {
    window.location.href = "https://wa.me/919159038012?text=Hello,%20I%20would%20like%20to%20book%20an%20appointment.%20My%20preferred%20date%20is:%20_________%20and%20time%20is:%20_________";
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-gray-800">Redirecting to WhatsApp...</h2>
        <p className="mt-2 text-gray-600">If you are not redirected automatically, <a href="https://wa.me/919159038012?text=Hello,%20I%20would%20like%20to%20book%20an%20appointment.%20My%20preferred%20date%20is:%20_________%20and%20time%20is:%20_________" className="text-indigo-600 underline">click here</a>.</p>
      </div>
    </div>
  );
}
